import Swal from 'sweetalert2';

//console.log(baseUrl)

const getSensors = ( plantaciones, allPlantaciones=true, indexPlantacion=-1 ) => {
    try {
        let sensors = [];
        ///get sensors for plantations mongo
        if(allPlantaciones){
        plantaciones.map((plantacion)=>{
            plantacion.sensores.map((sensor)=>{
            sensors.push({"name": sensor.name, "dev_eui":sensor.dev_eui});
            });
        });
        }else{
        
            plantaciones[indexPlantacion].sensores.map((sensor)=>{
                sensors.push({"name": sensor.name, "dev_eui":sensor.dev_eui});
            });
        }
        return sensors;
    }catch (error) {
        console.log(error);
        Swal.fire('Error de funcion', "No existen sensores 0x0HS01", 'error');
    }
}

const getSensorsStr = ( sensors ) => {
    
    //TODO Se debe validar si esta corriente antes de pedir un tocken nuevo///////////
    let sensorStr = "";
    try {

        sensors.map((row)=>{
            sensorStr += row.dev_eui+',';
        });
        sensorStr = sensorStr.slice(0, -1)
        return sensorStr;

    } catch (error) {
        console.log(error);
        Swal.fire('Error de parsing', "No se pudo extraer sensores 0x0HS02", 'error');
    }
    
}

const mapSensorsList = ( plantaciones, allPlantaciones=true, indexPlantacion=-1 ) => {
    try {
        let mapSensors = [];
        ///get sensors for plantations mongo
        if(allPlantaciones){
        plantaciones.map((plantacion)=>{
            plantacion.sensores.map((sensor)=>{
                mapSensors.push({"value":sensor.dev_eui, "label": sensor.name });
            });
        });
        }else{
        
        plantaciones[indexPlantacion].sensores.map((sensor)=>{
            mapSensors.push({"value":sensor.dev_eui, "label": sensor.name });
        });
        }
        return mapSensors;
    }catch (error) {
        console.log(error);
        Swal.fire('Error de funcion', "No existen sensores 0x0HS08", 'error');
    }
}

const mapSelectedSensorsStr = ( sensors ) => {
    
    //TODO Se debe validar si esta corriente antes de pedir un tocken nuevo///////////
    let sensorStr = "";
    try {

        sensors.map((row)=>{
            if (!row.value) {  //si es undefined es porque viene de getSensors array es con deveui en lugar de la lista de sensores con value
                console.log("row_value en mapSelectedSensorsStr:", row.value)
                sensorStr += row.dev_eui+',';
            }else{
                sensorStr += row.value+',';
            }
            
        });
        sensorStr = sensorStr.slice(0, -1)
        return sensorStr;

    } catch (error) {
        console.log(error);
        Swal.fire('Error de parsing', "No se pudo extraer sensores 0x0HS04", 'error');
    }
    
}

const transformDateRange = ( range ) => {
    let newRange=[];
    let startDate = "-12h";
    let endDate = "now()";
    if (range[0] && range[0]!=null) {
        startDate = range[0]._d.toISOString();
        //console.log("date start GMTstring:", value[0]._d.toGMTString());
        //console.log("date start UTCstring:", value[0]._d.toUTCString());
        console.log("date start ISOstring:", range[0]._d.toISOString());

    }
    if (range[1] && range[1]!=null) {
        endDate = range[1]._d.toISOString();
        console.log("date end:", range[1]._d.toISOString());
    }
    newRange.push(startDate);
    newRange.push(endDate);
    
    return newRange;

}

export {
    getSensors,
    getSensorsStr,
    mapSensorsList,
    mapSelectedSensorsStr,
    transformDateRange,
}